import { ApolloLinkScalar } from "@config/apollo/apollo-link.type";
import { WKT } from "ol/format";
import { Geometry } from "ol/geom";

export const GeometryScalar: () => ApolloLinkScalar<Geometry> = () => {
    const wkt = new WKT();
    return {
        parseValue: (value: unknown) => {
            try {
                if (typeof value !== "string") throw new Error("Can't parse a non string value");
                return wkt.readGeometry(value, { dataProjection: "EPSG:4326", featureProjection: "EPSG:3857" });
            } catch (err) {
                console.error("Error parsing geometry scalar", err);
                return null;
            }
        },
        serialize: (value: unknown) => {
            if (!(value instanceof Geometry)) {
                const error = new Error("Can't serialize a non geometry value");
                console.error(error);
                throw error;
            }
            return wkt.writeGeometry(value, { dataProjection: "EPSG:4326", featureProjection: "EPSG:3857" });
        },
    };
};
